export enum PaymentMethods {
  CREDIT_CARD = 'CREDIT_CARD',
  DIRECT_DEBIT = 'DIRECT_DEBIT',
  INVOICE = 'INVOICE',
  EXTERNAL_COLLECTION = 'EXTERNAL_COLLECTION',
  PAYPAL = 'PAYPAL',
  MANUAL_TRANSFER = 'MANUAL_TRANSFER'
}
